import {Component, Input, OnInit} from '@angular/core';

import {AuthService} from '../../../core/service/auth.service';
import {File} from '../files/model/file';
import {FilesService} from '../files/files.service';
import {FileDownloadService} from "../../../shared/components/file_download/file_download.service";

import Swal from 'sweetalert2';

@Component({
  selector: 'app-last-files',
  templateUrl: './last-files.component.html',
  styleUrls: ['./last-files.component.scss']
})
export class LastFilesComponent implements OnInit {

  @Input() fileType: string;
  @Input() colSize: number = 12;
  @Input() limit: number = 3;

  loading: boolean;
  filesUnsubscribe: Array<File>;
  files: Array<File>;

  constructor(private filesSrv: FilesService, private authService: AuthService, private fileDownload: FileDownloadService) {
      this.loading = false;
      this.files = [];
      this.filesUnsubscribe = [];

      this.fileDownload.getSubject().asObservable().subscribe(msg => {
          Swal('File download error', msg, 'error');
      });
  }

  ngOnInit() {
      this.findFiles();
  }

  findFiles() {
      this.loading = true;
      //const query = { 'gen_type' : this.fileType };
      this.filesSrv.findFilesToDownload({}).subscribe(
          (files: File[]) => {
              //this.files = data;
              files.forEach( (file: File) => {
                  (file.gen_type == 'unsubscribe')
                      ? this.filesUnsubscribe.push(file)
                      : this.files.push(file)
                  ;
              });

              this.loading = false;
          }
      )
  }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/components/last-files/last-files.component.ts